import { render, staticRenderFns } from "./TheSchoolEdit.vue?vue&type=template&id=39debbac&scoped=true&"
import script from "./TheSchoolEdit.vue?vue&type=script&lang=js&"
export * from "./TheSchoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./TheSchoolEdit.vue?vue&type=style&index=0&id=39debbac&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39debbac",
  null
  
)

export default component.exports